(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .directive('xxScrollBox', xxScrollBox);

    function xxScrollBox() {
        return {
            restrict: 'EA',
            controller: ScrollBoxCtrl,
            controllerAs: 'vm',
            bindToController: true,
            transclude: 'element',
            priority: 599,
            terminal: true,
            scope: { datasource: '=', pageSize: '=?', delay: '=?', threshold: '=?' }
        };
    }

    var SCROLL_KEYS = { UP: 38, DOWN: 40, PAGEUP: 33, PAGEDOWN: 34 };

    ScrollBoxCtrl.$inject = ['$scope', '$element', '$transclude', '$timeout', '$animate', 'scrollData', 'loadingPanel', 'itemElement'];
    function ScrollBoxCtrl($scope, $element, $transclude, $timeout, $animate, $scrollData, loadingPanel, itemElement) {
        var vm = this,
            scrollParent, childScope, content,
            suppressScroll, scrollData,
            keysDown = {};

        // Properties
        vm.pageSize = vm.pageSize || 100;
        vm.itemCount = vm.pageSize;
        vm.itemIndex = vm.itemIndex || 0;
        vm.itemHeight = 0;
        vm.threshold = vm.threshold || 0;
        vm.delay = vm.delay || 250;

        // Methods
        vm.$onInit = init;
        vm.refresh = refresh;

        ////////////////////////////////////////////////

        // Init
        function init() {
            addContent();
            scrollParent = getScrollParent();
            scrollParent.on('scroll', scroll);
            scrollParent.on('keydown', keydown);
            scrollParent.on('keyup', keyup);

            $scope.$watchGroup(['vm.pageSize', 'vm.itemIndex'], refresh);
            $scope.$watch(visibilityWatch);
            $scope.$on('$destroy', destroy);
        }
        function destroy() {
            scrollParent.off('scroll', scroll);
            scrollParent.off('keydown', keydown);
            scrollParent.off('keyup', keyup);
        }

        // Core
        function refresh() {
            var datasource = vm.datasource,
                options = { $skip: vm.itemIndex, $top: vm.pageSize, $count: true };

            if (isVisible())
                loadingPanel(scrollParent, true);

            console.log('refresh');
            return datasource(options)
                .then(success)
                .finally(final);

            function success(data) {
                vm.itemCount = data.$count;
                childScope.$data = data;

                if (isVisible()) {
                    $animate.enabled($element, false);
                    $scope.$$postDigest(render);
                }
            }
            function final() {
                $timeout(loadingPanel.bind(null, scrollParent, false), 0, false);
            }
        }
        function scroll(e, done) {
            if (suppressScroll)
                return suppressScroll = false;

            if (getScrollData()) 
                loadingPanel(scrollParent, true);

            $timeout.cancel(scroll.timer);
            if (!done || isScrollKeyDown()) {
                scroll.timer = $timeout(scroll.bind(this, e, true), vm.delay);
                return;
            }
            scroll.timer = null;
            loadingPanel(scrollParent, false);
            if (scrollData = getScrollData())
                vm.itemIndex = scrollData.index; // <== will trigger refresh
        }
        function render() {
            var
                data = childScope.$data,
                height = vm.itemHeight || (vm.itemHeight = getAverageHeight()),
                marginTop = vm.itemIndex * height,
                marginBottom = (vm.itemCount - vm.itemIndex - vm.pageSize) * height;

            $animate.enabled($element, true);
            content.css('margin-top', Math.max(0, marginTop) + 'px');
            content.css('margin-bottom', Math.max(0, marginBottom) + 'px');

            scrollData = scrollData || { };
            switch (scrollData.scrollFrom) {
                case "begin":
                    scrollParent.scrollTop(scrollData.scrollOffset);
                    break;
                case "end":
                    scrollParent.scrollTop(scrollParent.scrollHeight() + scrollData.scrollOffset);
                    break;
                case "element":
                    var item = scrollData.elementId && data.find(findFunc) || data[scrollData.elementIndex];
                    if (item) {
                        var element = itemElement(item);
                        scrollParent.scrollTop(offsetTop(element) - scrollData.scrollOffset);
                        // The old way...
                        // element.scrollIntoView(true);
                        // scrollParent.scrollTop(scrollParent.scrollTop() - scrollData.scrollOffset);
                    }
                    break;
            }

            scrollData = null;
            suppressScroll = true;

            function findFunc(item) {
                return item.id == scrollData.elementId;
            }
        }

        // Key Stuff
        function keydown(e) {
            keysDown[e.which] = true;
            if (scroll.timer)
                scroll();
        }
        function keyup(e) {
            keysDown[e.which] = false;
        }
        function isScrollKeyDown() {
            return keysDown[SCROLL_KEYS.UP] || keysDown[SCROLL_KEYS.DOWN] ||
                keysDown[SCROLL_KEYS.PAGEUP] || keysDown[SCROLL_KEYS.PAGEDOWN];
        }

        // Helpers
        function addContent() {
            $transclude(transcludeFunc);
            function transcludeFunc(clone, scope) {
                childScope = scope;
                $element.after($element = content = clone);
            }
        }
        function getScrollParent() {
            var result, dummy;
            $element.append(dummy = angular.element('<div />'));
            result = dummy.scrollParent();
            dummy.remove();
            return result;
        }
        function getAverageHeight() {
            var data = childScope.$data;
            return data.reduce(sumHeight, 0) / data.length
            function sumHeight(prev, curr) {
                var element = itemElement(curr);
                return prev + element.prop('offsetHeight');
            }
        }
        function getScrollData() {
            var options = {
                scrollParent: scrollParent,
                scrollBox: $element,
                data: childScope.$data,
                pageSize: vm.pageSize,
                itemIndex: vm.itemIndex,
                itemCount: vm.itemCount,
                itemHeight: vm.itemHeight,
                threshold: vm.threshold,
            };
            return $scrollData(options)
        }
        function isVisible() {
            var elem = $element[0];
            var result = !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
            return result;
        }
        function visibilityWatch() {
            $timeout(visibilityWatchAction, 0, false);

            function visibilityWatchAction() {
                var oldValue = visibilityWatch.visible;
                var newValue = visibilityWatch.visible = isVisible();
                if (oldValue != newValue && newValue)
                    render();
            }
        }
        function offsetTop(element) {
            var parent = scrollParent[0], result = 0;
            for (var elem = element[0]; elem && elem != scrollParent; elem = elem.offsetParent)
                result += elem.offsetTop;
            return result;
        }
    }
})();